import { getExternalUserId } from 'api/utils'
import { useAuth } from 'auth'
import { GlobalShell } from 'components/GlobalShell'
import { useWorkspaceChange } from 'hooks/useWorkspaceChange'
import { useHistory } from 'lib/router'
import { useHydrateStore } from 'state/store'
import WorkspaceSwitcher from 'views/WorkspaceSwitcher'

export const WorkspaceSwitcherContainer = () => {
  const history = useHistory()
  const { latestToken: token } = useAuth()
  const onWorkspaceChange = useWorkspaceChange()
  useHydrateStore(getExternalUserId(token))

  return (
    <GlobalShell>
      <WorkspaceSwitcher
        onWorkspaceSelect={ids => {
          onWorkspaceChange(ids)
          history.push('/')
        }}
      />
    </GlobalShell>
  )
}
